import { DateRangeBox, SelectBox, TagBox } from 'devextreme-react';
import ExcelJS from 'exceljs';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { Card, Col, Collapse, Input, Row } from 'reactstrap';
import * as XLSX from 'xlsx';
import api from '../../../../services/api-configuration';
import { getAllWarehouses } from '../../../../services/apis';
import PopoverInfoIcon from '../../../../utils/PopoverInfoIcon';
import { getGroupageDetails } from '../api';
import { Grupaj } from '../print/Grupaj';

const GrupajFilterArea = ({
    onFilter,
    setIsOpen,
    groupageRef,
    setGroupageDetails
}) => {
    const [showFilters, setShowFilters] = useState(true);
    const [warehouseData, setWarehouseData] = useState([]);
    const [cityData, setCityData] = useState([]);
    const [sevkiyatData, setSevkiyatData] = useState([]);

    const commonSettings = {
        showClearButton: true,
        openOnFieldClick: false,
        startLabel: "Başlangıç Tarihi",
        endLabel: "Bitiş Tarihi",
        startDateLabel: "Başlangıç Tarihi",
        endDateLabel: "Bitiş Tarihi",


    };

    useEffect(() => {
        const fetchInitialData = async () => {
            try {
                // Fetch warehouses
                const warehousesResponse = await getAllWarehouses();
                setWarehouseData(warehousesResponse);

                // Fetch cities
                const citiesResponse = await api.post("/city/getAll");
                let allCities = citiesResponse.data.data || [];
                // Alfabetik sıralama
                allCities.sort((a, b) => a.city_name.localeCompare(b.city_name));
                // ID 7'yi filtrele
                setCityData(allCities.filter((item) => (item.id !== 7)));

                // Fetch shipping types
                const shippingResponse = await api.post("shippingType/getAll");
                setSevkiyatData(shippingResponse.data.data || []);

            } catch (error) {
                console.error("Error fetching initial data:", error);
                toast.error("Veriler yüklenirken hata oluştu", {
                    position: "top-center",
                    autoClose: 3000
                });
            }
        };

        fetchInitialData();
    }, []);

    const handleFilter = () => {
        onFilter();
    };

    const handleExportExcel = async () => {
        try {
            // Get all groupage numbers from all pages using the store

            if (groupageRef.current.instance.getDataSource() === null) {
                toast.warning("Tabloda Veri Bulunamadı", {
                    position: "top-center",
                    autoClose: 3000
                })
                return
            }
            const store = groupageRef.current.instance.getDataSource().store();
            const allData = await store.load();
            const allGroupageNos = allData.map(item => item.groupage_no);

            const response = await api.post("/getGroupageReport", {
                grupaj_nos: allGroupageNos
            });

            const data = response.data || [];
            const workbook = new ExcelJS.Workbook();
            const worksheet = workbook.addWorksheet('Grupaj Raporu');

            // Define columns with autoFilter
            worksheet.columns = [
                { header: 'GrupajNo', key: 'grupaj_no', width: 20 },
                { header: 'SevkiyatTipiAdi', key: 'sevkiyat_tipi_adi', width: 20 },
                { header: 'RotaAdi', key: 'rota_adi', width: 30 },
                { header: 'Sase', key: 'sase', width: 20 },
                { header: 'GrupajTarih', key: 'grupaj_tarih', width: 20 },
                { header: 'PlanlamaTarih', key: 'planlama_tarih', width: 20 },
                { header: 'BilgiGelisTarih', key: 'bilgi_gelis_tarih', width: 20 },
                { header: 'IrsaliyeTarih', key: 'irsaliye_tarih', width: 20 },
                { header: 'MatbuIrsaliyeNo', key: 'matbu_irsaliye_no', width: 20 },
                { header: 'KapiCikisTarih', key: 'kapi_cikis_tarih', width: 20 },
                { header: 'TaseronFirmaAdi', key: 'taseron_firma_adi', width: 20 },
                { header: 'TirPlaka', key: 'tir_plaka', width: 15 },
                { header: 'TirSoforAdiSoyadi', key: 'tir_sofor_adi_soyadi', width: 25 },
                { header: 'GrupajStatuAciklama', key: 'grupaj_statu_aciklama', width: 25 },
                { header: 'FromLokasyonAdi', key: 'from_lokasyon_adi', width: 25 },
                { header: 'FromLokasyonIl', key: 'from_lokasyon_il', width: 20 },
                { header: 'ToLokasyonAdi', key: 'to_lokasyon_adi', width: 25 },
                { header: 'JustToLokasyonAdi', key: 'just_to_lokasyon_adi', width: 25 },
                { header: 'ToLokasyonIl', key: 'to_lokasyon_il', width: 20 },
                { header: 'ToLokasyon', key: 'to_lokasyon', width: 20 },
                { header: 'PeronAciklama', key: 'peron_aciklama', width: 25 },
                { header: 'SevkiyatNotu', key: 'sevkiyat_notu', width: 20 },
                { header: 'PDI', key: 'pdi', width: 10 },
                { header: 'DorsePlaka', key: 'dorse_plaka', width: 15 },
                { header: 'TirEslemeTarih', key: 'tir_esleme_tarih', width: 20 },
                { header: 'SevkHazirlikTarih', key: 'sevke_hazir_tarihi', width: 20 },
                { header: 'MarkaAdi', key: 'marka_adi', width: 15 },
                { header: 'Versiyon', key: 'versiyon', width: 50 },
                { header: 'ModelAdi', key: 'model_adi', width: 15 },
                { header: 'RenkAdi', key: 'renk_adi', width: 20 },
                { header: 'ToLokasyonBolgeCode', key: 'to_lokasyon_bolge_code', width: 25 },
                { header: 'FizikiYuklemeTarih', key: 'fiziki_yukleme_tarih', width: 20 },
                { header: 'FizikiTeslimTarih', key: 'fiziki_teslim_tarih', width: 20 },
                { header: 'OtomobilDurum', key: 'otomobil_durum', width: 20 },
                { header: 'DepoParkAdres', key: 'depo_park_adres', width: 20 },
                { header: 'SaseAdresBolge', key: 'sase_adres_bolge', width: 20 },
                { header: 'PDIDurum', key: 'pdi_durum', width: 15 },
                { header: 'FaturaTarihiBilgisi', key: 'fatura_tarih_bilgisi', width: 20 },
                { header: 'PDITarih', key: 'pdi_tarih', width: 20 },
                { header: 'CreUserCode', key: 'cre_user_code', width: 15 },
                { header: 'ModUserCode', key: 'mod_user_code', width: 15 }
            ];

            // Style the header row
            const headerRow = worksheet.getRow(1);
            headerRow.eachCell((cell) => {
                cell.fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: { argb: '4472C4' }  // Blue background
                };
                cell.font = {
                    color: { argb: 'FFFFFF' },
                    bold: true
                };
                cell.alignment = {
                    horizontal: 'center',
                    vertical: 'middle'
                };
                cell.border = {
                    top: { style: 'thin', color: { argb: 'D9D9D9' } },
                    left: { style: 'thin', color: { argb: 'D9D9D9' } },
                    bottom: { style: 'thin', color: { argb: 'D9D9D9' } },
                    right: { style: 'thin', color: { argb: 'D9D9D9' } }
                };
            });

            // Add data rows with alternating colors
            data.forEach((item, index) => {
                const row = worksheet.addRow(item);
                const isEvenRow = index % 2 === 0;

                worksheet.columns.forEach((col, colIndex) => {
                    const cell = row.getCell(colIndex + 1);
                    cell.fill = {
                        type: 'pattern',
                        pattern: 'solid',
                        fgColor: { argb: isEvenRow ? 'F2F2F2' : 'FFFFFF' }
                    };
                    cell.alignment = {
                        horizontal: 'center',
                        vertical: 'middle'
                    };
                    cell.border = {
                        top: { style: 'thin', color: { argb: 'D9D9D9' } },
                        left: { style: 'thin', color: { argb: 'D9D9D9' } },
                        bottom: { style: 'thin', color: { argb: 'D9D9D9' } },
                        right: { style: 'thin', color: { argb: 'D9D9D9' } }
                    };
                });
            });

            // Enable AutoFilter
            worksheet.autoFilter = {
                from: { row: 1, column: 1 },
                to: { row: 1, column: worksheet.columns.length }
            };

            // Adjust column widths
            worksheet.columns.forEach((column) => {
                const maxLength = Math.max(
                    ...worksheet.getColumn(column.key).values
                        .filter(value => value)
                        .map(value => value.toString().length)
                );
                column.width = Math.min(Math.max(maxLength + 2, 15), 30);
            });

            // Generate and download the file
            const buffer = await workbook.xlsx.writeBuffer();
            const blob = new Blob([buffer], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = `Grupaj_Detayları_${moment().format('DD.MM.YYYY HH:mm:ss')}.xlsx`;
            a.click();
            window.URL.revokeObjectURL(url);

        } catch (error) {
            console.error("Error exporting grupaj report:", error);
            toast.error("Grupaj raporu oluşturulurken hata oluştu", {
                position: "top-center",
                autoClose: 3000
            });
        }
    };

    const handlePrintAll = async () => {
        try {
            const selectedRows = groupageRef.current.instance.getSelectedRowKeys();
            if (!selectedRows || selectedRows.length === 0) {
                toast.warning("Lütfen en az bir grupaj seçiniz", {
                    position: "top-center",
                    autoClose: 3000
                });
                return;
            }

            if (selectedRows.length > 5) {
                toast.warning("En fazla 5 grupaj seçebilirsiniz", {
                    position: "top-center",
                    autoClose: 3000
                });
                return;
            }

            // Tüm seçili grupajların detaylarını al
            const grupajDetails = await Promise.all(
                selectedRows.map(row => getGroupageDetails(row.groupage_no))
            );

            // Hepsini tek seferde yazdır
            await Grupaj(grupajDetails.filter(Boolean), selectedRows, onFilter);

        } catch (error) {
            console.error("Yazdırma işlemi sırasında hata:", error);
            toast.error("Yazdırma işlemi sırasında hata oluştu", {
                position: "top-center",
                autoClose: 3000
            });
        }
    };

    const handlePDIEmriListesi = async () => {
        try {
            if (!groupageRef.current) {
                toast.warning("Lütfen grupaj seçiniz", {
                    position: "top-center",
                    autoClose: 3000
                });
                return;
            }

            const selectedRows = groupageRef.current.instance.getSelectedRowKeys();
            if (!selectedRows || selectedRows.length === 0) {
                toast.warning("Lütfen grupaj seçiniz", {
                    position: "top-center",
                    autoClose: 3000
                });
                return;
            }

            const groupageNos = selectedRows.map(row => row.groupage_no);

            // Call API for each selected groupage
            const response = await api.post("/getChassisListByGroupage", {
                groupage_no: groupageNos
            });

            if (response.data.success) {
                const chassisNumbers = response.data.chassis_no;
                if (!chassisNumbers || chassisNumbers.length === 0) {
                    toast.warning("Seçili grupajlarda PDI emri oluşturulacak şase bulunamadı", {
                        position: "top-center",
                        autoClose: 3000
                    });
                    return;
                }
                // Create Excel workbook
                const wb = XLSX.utils.book_new();
                const currentDate = moment().format('DD/MM/YYYY');

                // Prepare data with the specified columns
                const excelData = [
                    ["sase", "PLANLAMA TARIHI", "YENİ/IPTAL"], // Header
                    ...chassisNumbers.map(chassis => [
                        chassis,
                        currentDate,
                        "YENİ"
                    ])
                ];

                const ws = XLSX.utils.aoa_to_sheet(excelData);

                // Set column widths based on content
                const colWidths = [
                    { wch: 20 },  // SASE column
                    { wch: 15 },  // PLANLAMA TARIHI column
                    { wch: 12 }   // YENİ/IPTAL column
                ];
                ws['!cols'] = colWidths;

                // Format date column and ensure it's treated as text to prevent ### display
                const dateRange = XLSX.utils.decode_range(ws['!ref']);
                for (let row = 1; row <= dateRange.e.r; row++) {
                    const cellRef = XLSX.utils.encode_cell({ r: row, c: 1 }); // Column B (PLANLAMA TARIHI)
                    if (ws[cellRef]) {
                        ws[cellRef].t = 's';  // Set cell type as string
                        ws[cellRef].v = moment(ws[cellRef].v).format('DD/MM/YYYY');  // Format date
                    }
                }

                // Add worksheet to workbook
                XLSX.utils.book_append_sheet(wb, ws, "PDI Emri Listesi");

                // Generate Excel file
                const fileDate = moment().format('YYYY-MM-DD_HH-mm');
                XLSX.writeFile(wb, `PDI_Emri_Listesi_${fileDate}.xlsx`);

                window.open(`${process.env.PUBLIC_URL}/pdi-emir`, "_blank");

            } else {
                toast.error(response.data.message || "PDI Emri listesi alınamadı", {
                    position: "top-center",
                    autoClose: 3000
                });
            }
        } catch (error) {
            console.error("PDI Emri listesi alınırken hata:", error);
            toast.error("PDI Emri listesi alınırken hata oluştu", {
                position: "top-center",
                autoClose: 3000
            });
        }
    };

    const handleGetChassisFromDock = async () => {
        try {
            if (!groupageRef.current) {
                toast.warning("Lütfen grupaj seçiniz", {
                    position: "top-center",
                    autoClose: 3000
                });
                return;
            }

            const selectedRows = groupageRef.current.instance.getSelectedRowKeys();
            if (!selectedRows || selectedRows.length === 0) {
                toast.warning("Lütfen grupaj seçiniz", {
                    position: "top-center",
                    autoClose: 3000
                });
                return;
            }

            const groupageNos = selectedRows.map(row => row.groupage_no);

            // Call API to get chassis from dock
            const response = await api.post("/getChassisFromTheDock", {
                groupage_no: groupageNos
            });

            if (response.data.success) {
                const chassisNumbers = response.data.chassis_no;
                if (!chassisNumbers || chassisNumbers.length === 0) {
                    toast.warning("Seçili grupajlarda rıhtımdan talep edilecek şase bulunmamaktadır", {
                        position: "top-center",
                        autoClose: 3000
                    });
                    return;
                }

                // Create Excel workbook
                const wb = XLSX.utils.book_new();

                // Prepare data with only chassis column
                const excelData = [
                    ["sase"], // Header
                    ...chassisNumbers.map(chassis => [chassis])
                ];

                const ws = XLSX.utils.aoa_to_sheet(excelData);

                // Set column width
                ws['!cols'] = [{ wch: 20 }]; // SASE column width

                // Add worksheet to workbook
                XLSX.utils.book_append_sheet(wb, ws, "Rıhtım Şase Listesi");

                // Generate Excel file
                const fileDate = moment().format('YYYY-MM-DD_HH-mm');
                XLSX.writeFile(wb, `Rihtim_Sase_Listesi_${fileDate}.xlsx`);

            } else {
                toast.error("Şase listesi alınamadı", {
                    position: "top-center",
                    autoClose: 3000
                });
            }
        } catch (error) {
            console.error("Rıhtım şase listesi alınırken hata:", error);
            toast.error("Rıhtım şase listesi alınırken hata oluştu", {
                position: "top-center",
                autoClose: 3000
            });
        }
    };

    return (
        <Card>
            <div className="rounded bg-white mb-1">
                <div className="p-2 border-b flex justify-between items-center d-flex justify-content-between align-items-center">
                    <div className="flex items-center gap-2">
                        <i className="fa fa-filter"></i> &nbsp;
                        <span className="font-medium">Kriterler</span>
                    </div>
                    <i
                        style={{ fontSize: 18, cursor: 'pointer' }}
                        className={`fa fa-chevron-${showFilters ? 'up' : 'down'} cursor-pointer text-gray-600`}
                        onClick={() => setShowFilters(!showFilters)}
                    />
                </div>

                <Collapse isOpen={showFilters}>
                    <div className="p-3">
                        <Row className="mb-1">
                            <Col md="6">
                                <Row>
                                    <label className="block mb-1 col-md-4 col-sm-6"><b>Grupaj No</b></label>
                                    <Input
                                        id="grupajNo"
                                        placeholder="Grupaj No"
                                        showClearButton={true}
                                        className="form-control col-md-7 col-sm-6"
                                    />
                                </Row>
                            </Col>
                            <Col md="6">
                                <Row>
                                    <label className="block mb-1 col-md-4 col-sm-6 d-flex align-items-center">
                                        <b>Planlanan Sevk Tarihi</b>
                                    </label>
                                    <DateRangeBox
                                        {...commonSettings}
                                        className="col-md-7 col-sm-6"
                                        id="planlananSevkTarihi"
                                    />
                                </Row>
                            </Col>
                        </Row>

                        <Row className="mb-1">
                            <Col md="6">
                                <Row>
                                    <label className="block mb-1 col-md-4 col-sm-6"><b>Şase</b></label>
                                    <input
                                        id="sase"
                                        placeholder="Şase"
                                        className="form-control col-md-7 col-sm-6"
                                    />
                                </Row>
                            </Col>
                            <Col md="6">
                                <Row>
                                    <label className="block mb-1 col-md-4 col-sm-6 d-flex align-items-center">
                                        <b>Grupaj Onay Tarih Aralığı</b>
                                    </label>
                                    <DateRangeBox
                                        {...commonSettings}
                                        className="col-md-7 col-sm-6"
                                        id="grupajOnayTarih"
                                    />
                                </Row>
                            </Col>
                        </Row>

                        <Row className="mb-1">
                            <Col md="6">
                                <Row>
                                    <label className="block mb-1 col-md-4 col-sm-6"><b>Sevkiyat Tipi</b></label>
                                    <TagBox
                                        id="sevkiyatTipi"
                                        dataSource={sevkiyatData}
                                        displayExpr="type_name"
                                        valueExpr="id"
                                        searchEnabled={true}
                                        placeholder="Sevkiyat Tipi"
                                        className="col-md-7 col-sm-6"
                                    />
                                </Row>
                            </Col>
                            <Col md="6">
                                <Row>
                                    <label className="block mb-1 col-md-4 col-sm-6 d-flex align-items-center">
                                        <b>Bilgi Geliş Tarihi</b>
                                    </label>
                                    <DateRangeBox
                                        {...commonSettings}
                                        className="col-md-7 col-sm-6"
                                        id="bilgiGelisTarihi"
                                    />
                                </Row>
                            </Col>
                        </Row>

                        <Row className="mb-1">
                            <Col md="6">
                                <Row>
                                    <label className="block mb-1 col-md-4 col-sm-6"><b>Grupaj Statü</b></label>
                                    <TagBox
                                        id="grupajStatu"
                                        dataSource={[
                                            { id: "Grupaj Onaylandı", name: "Grupaj Onaylandı" },
                                            { id: "Tır Eşlendi", name: "Tır Eşlendi" },
                                            { id: "Çıkış Yapıldı", name: "Çıkış Yapıldı" },
                                            { id: "Onay İptal", name: "Onay İptal Edildi" },
                                            { id: "Teslim Edildi", name: "Teslim Edildi (Aktif Değil)" }
                                        ]}
                                        displayExpr="name"
                                        valueExpr="id"
                                        placeholder="Grupaj Statüsü"
                                        className="col-md-7 col-sm-6"
                                    />
                                </Row>
                            </Col>
                            <Col md="6">
                                <Row>
                                    <label className="block mb-1 col-md-4 col-sm-6 d-flex align-items-center">
                                        <b>Depo Çıkış Tarihi</b>
                                    </label>
                                    <DateRangeBox
                                        {...commonSettings}
                                        className="col-md-7 col-sm-6"
                                        id="depoCikisTarihi"
                                    />
                                </Row>
                            </Col>
                        </Row>

                        <Row className="mb-1">
                            <Col md="6">
                                <Row>
                                    <label className="block mb-1 col-md-4 col-sm-6"><b>Grupaj Yazdırma Durum</b></label>
                                    <SelectBox
                                        id="grupajYazdırmaDurum"
                                        defaultValue={3}
                                        dataSource={[
                                            { id: 1, name: "Yazdırılmamış" },
                                            { id: 2, name: "Yazdırılmış" },
                                            { id: 3, name: "Hepsi" }
                                        ]}
                                        displayExpr="name"
                                        valueExpr="id"
                                        placeholder="Yazdırma Durumu"
                                        className="col-md-7 col-sm-6"
                                    />
                                </Row>
                            </Col>
                            <Col md="6">
                                <Row>
                                    <label className="block mb-1 col-md-4 col-sm-6 d-flex align-items-end"><b>Grupaj Depo &nbsp; </b>
                                        <PopoverInfoIcon
                                            index={"1"}
                                            text=""
                                            textInfoBreak={`Grupaj oluşturulurken seçilen "Nereden" kısmındaki ana depodur.`}
                                        />

                                    </label>
                                    <TagBox
                                        id="grupajDepo"
                                        dataSource={warehouseData}
                                        displayExpr="warehouse_name"
                                        valueExpr="id"
                                        placeholder="Depo Seçiniz"
                                        className="col-md-7 col-sm-6"
                                    />
                                </Row>
                            </Col>
                        </Row>

                        <Row className="mb-1">
                            <Col md="6">
                                <Row>
                                    <label className="block mb-1 col-md-4 col-sm-6"><b>Nereye (İL)</b></label>
                                    <TagBox
                                        id="nereye-il"
                                        dataSource={cityData}
                                        displayExpr="city_name"
                                        valueExpr="id"
                                        searchEnabled={true}
                                        placeholder="İl Seçiniz"
                                        className="col-md-7 col-sm-6"
                                    />
                                </Row>
                            </Col>
                            <Col md="6">
                                <Row>
                                    <label className="block mb-1 col-md-4 col-sm-6"><b>Nereye (DEPO)</b></label>
                                    <TagBox
                                        id="nereye"
                                        dataSource={warehouseData}
                                        displayExpr="warehouse_name"
                                        valueExpr="id"
                                        searchEnabled={true}
                                        placeholder="Depo Seçiniz"
                                        className="col-md-7 col-sm-6"
                                    />
                                </Row>
                            </Col>
                        </Row>
                        <Row>

                            <Col md="6">
                                <Row>
                                    <label className="block mb-1 col-md-4 col-sm-6 d-flex align-items-center"><b>Çıkış Deposu &nbsp; </b>
                                        <PopoverInfoIcon
                                            index={"2"}
                                            text={""}
                                            textInfoBreak={` Şasenin fiziksel olarak bulunduğu ve çıkış yapacağı/yaptığı depodur.`}
                                        />
                                    </label>
                                    <TagBox
                                        id='depoCikisDepo'
                                        dataSource={warehouseData}
                                        displayExpr="warehouse_name"
                                        valueExpr="id"
                                        searchEnabled={true}
                                        placeholder="Depo Seçiniz"
                                        className="col-md-7 col-sm-6"
                                    />
                                </Row>
                            </Col>
                            {/* <Col md="6">

                                <div style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "flex-end",
                                    gap: "10px"
                                }}>
                                    <button
                                        onClick={handleFilter}
                                        id='filter-button'
                                        style={{
                                            border: "1px solid #ddd",
                                            background: "#f3f3f3",
                                            color: "white",
                                            padding: "8px"
                                        }}
                                        className="btn btn-success"
                                    >
                                        <i className="fa fa-list mr-2" />
                                        Listele
                                    </button>
                                    <button
                                        onClick={handleExportExcel}
                                        id='export-excel-button'
                                        style={{
                                            border: "1px solid #ddd",
                                            background: "#f3f3f3",
                                            color: "#3b3b3b",
                                            padding: "8px",
                                            minWidth: "120px",
                                            visibility: "hidden"
                                        }}
                                        className="btn"
                                    >
                                        <i className="fa fa-file-excel-o mr-2" />
                                        Excel'e Aktar
                                    </button>
                                </div>
                            </Col> */}
                        </Row>
                        <br />
                        <Row className="mb-1" style={{ justifyContent: "flex-end" }}>
                            <Col md="11" style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "flex-end"
                            }}>
                                <div style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "flex-end",
                                    gap: "10px"
                                }}>
                                    <button
                                        onClick={handleFilter}
                                        id='filter-button'
                                        style={{
                                            border: "1px solid #ddd",
                                            background: "#f3f3f3",
                                            color: "white",
                                            padding: "8px"
                                        }}
                                        className="btn btn-success"
                                    >
                                        <i className="fa fa-list mr-2" />
                                        Listele
                                    </button>
                                    <button
                                        onClick={handleExportExcel}
                                        id='export-excel-button'
                                        style={{
                                            border: "1px solid #ddd",
                                            background: "#f3f3f3",
                                            color: "#3b3b3b",
                                            padding: "8px",
                                            minWidth: "120px",
                                            visibility: "hidden"
                                        }}
                                        className="btn"
                                    >
                                        <i className="fa fa-file-excel-o mr-2" />
                                        Excel'e Aktar
                                    </button>
                                </div>
                            </Col>
                        </Row>
                        <br />
                        <Row className='mb-1'>
                            <Col md='7'>
                                <div className="d-flex gap-2" style={{
                                    gap: "10px", maxHeight: "120px"
                                }}>
                                    <button
                                        style={{
                                            border: "1px solid #ddd",
                                            background: "#f3f3f3",
                                            color: "#3b3b3b",
                                            padding: "6px",
                                            minWidth: "120px"
                                        }}
                                        id='print-all-button'
                                        className="btn"
                                        onClick={handlePrintAll}
                                    >
                                        <i style={{ fontSize: "20px" }} className='fa fa-print mr-2' />
                                        <br />
                                        Tümünü Yazdır
                                        <br />
                                        (Max:5 Grupaj)
                                    </button>
                                    <button
                                        style={{
                                            border: "1px solid #ddd",
                                            background: "#f3f3f3",
                                            color: "#3b3b3b",
                                            padding: "6px",
                                            minWidth: "120px"
                                        }}
                                        id='islemler-button'
                                        className="btn"
                                        onClick={async () => {
                                            const selectedRows = groupageRef.current.instance.getSelectedRowKeys();
                                            if (selectedRows.length !== 1) {
                                                toast.warning('Lütfen sadece bir grupaj seçiniz', {
                                                    position: "top-center",
                                                    autoClose: 3000
                                                });
                                                return;
                                            }
                                            let groupageNo = selectedRows[0].groupage_no;
                                            setIsOpen({ islemler: true });
                                            const response = await getGroupageDetails(groupageNo);
                                            setGroupageDetails(response);
                                        }}
                                    >
                                        <i style={{ fontSize: "20px" }} className="fa fa-cogs mr-2" />
                                        <br />
                                        İşlemler
                                    </button>
                                    <button
                                        style={{
                                            border: "1px solid #ddd",
                                            background: "#f3f3f3",
                                            color: "#3b3b3b",
                                            padding: "6px",
                                            minWidth: "120px"
                                        }}
                                        className="btn"
                                        id='peron-button'
                                        onClick={async () => {
                                            const selectedRows = groupageRef.current.instance.getSelectedRowKeys();
                                            if (selectedRows.length !== 1) {
                                                toast.warning('Lütfen sadece bir grupaj seçiniz', {
                                                    position: "top-center",
                                                    autoClose: 3000
                                                });
                                                return;
                                            }
                                            let groupageNo = selectedRows[0].groupage_no;
                                            setIsOpen({ peronGuncelle: true });
                                            const response = await getGroupageDetails(groupageNo);
                                            setGroupageDetails(response);
                                        }}
                                    >
                                        <i style={{ fontSize: "20px" }} className="fa fa-refresh mr-2" />
                                        <br />
                                        Peron Güncelleme
                                    </button>
                                    <button
                                        style={{
                                            border: "1px solid #ddd",
                                            background: "#f3f3f3",
                                            color: "#3b3b3b",
                                            padding: "6px",
                                            minWidth: "120px"
                                        }}
                                        id='pdi-emri-listesi-button'
                                        className="btn"
                                        onClick={async () => {
                                            const selectedRows = groupageRef.current.instance.getSelectedRowKeys();
                                            if (selectedRows.length === 0) {
                                                toast.warning('Lütfen en az bir grupaj seçiniz', {
                                                    position: "top-center",
                                                    autoClose: 3000
                                                });
                                                return;
                                            }
                                            handlePDIEmriListesi();
                                        }}
                                    >
                                        <i style={{ fontSize: "20px" }} className="fa fa-file-pdf-o mr-2" />
                                        <br />
                                        PDI Emri Listesi
                                    </button>
                                    <button
                                        style={{
                                            border: "1px solid #ddd",
                                            background: "#f3f3f3",
                                            color: "#3b3b3b",
                                            padding: "6px",
                                            minWidth: "120px"
                                        }}
                                        id='rihtim-istenecek-button'
                                        className="btn"
                                        onClick={async () => {
                                            const selectedRows = groupageRef.current.instance.getSelectedRowKeys();
                                            if (selectedRows.length === 0) {
                                                toast.warning('Lütfen en az bir grupaj seçiniz', {
                                                    position: "top-center",
                                                    autoClose: 3000
                                                });
                                                return;
                                            }
                                            handleGetChassisFromDock();
                                        }}
                                    >
                                        <i style={{ fontSize: "20px" }} className="fa fa-file mr-2" />
                                        <br />
                                        RIHTIM dan İstenecek
                                    </button>
                                </div>
                            </Col>
                            <Col md='5'>
                                <p
                                    style={{
                                        fontSize: "14px",
                                        background: "#fca0b0",
                                        padding: "10px",
                                        margin: 0,
                                        borderRadius: "4px"
                                    }}
                                >
                                    <strong>NOT: Grupaj Numarası Renkli Olan Grupajlarda Öncelikli Otomobiller var. İşlemlerinizi buna göre yapınız.</strong>
                                </p>
                            </Col>
                        </Row>
                    </div>
                </Collapse>
            </div >
        </Card >
    );
};

export default GrupajFilterArea;